import { defineComponent, h, onMounted, ref } from 'vue';

import { ResizeObserver } from '../ResizeObserver';

import type { NTable } from '../../interface';

interface IMeasureCellProps {
  columnKey: NTable.TKey;
  onColumnResize: (key: NTable.TKey, width: number) => void;
}

export default defineComponent<IMeasureCellProps>({
  name: 'MeasureCell',
  props: ['columnKey'] as any,
  emits: ['columnResize'],
  setup(props, { emit }) {
    const tdRef = ref<HTMLTableCellElement>();

    onMounted(() => {
      if (tdRef.value) {
        emit('columnResize', props.columnKey, tdRef.value.offsetWidth);
      }
    });

    return () =>
      h(
        ResizeObserver, // @todo maybe can change for useResizeObserver?
        {
          disabled: false,
          onResize: ({ offsetWidth }) => {
            emit('columnResize', props.columnKey, offsetWidth);
          }
        },
        {
          default: () =>
            h(
              'td',
              { ref: tdRef, style: { padding: 0, border: 0, height: 0 } },
              h('div', { style: { height: 0, overflow: 'hidden' } }, '&nbsp;')
            )
        }
      );
  }
});
